var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDropDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.246857 1.35343L4.91168 5.76985C5.06803 5.91726 5.27954 6 5.5 6C5.72046 6 5.93197 5.91726 6.08832 5.76985L10.7531 1.35343C10.8708 1.24273 10.9511 1.10129 10.9837 0.947153C11.0163 0.793016 10.9998 0.633161 10.9362 0.48797C10.8726 0.34278 10.7649 0.218831 10.6268 0.131927C10.4887 0.045022 10.3264 -0.000900775 10.1607 1.37916e-05L0.839349 1.33841e-05C0.673598 -0.000901197 0.511313 0.0450216 0.373188 0.131926C0.235063 0.218831 0.127355 0.342779 0.0637934 0.48797C0.000232931 0.633161 -0.0163 0.793015 0.0163033 0.947153C0.0489065 1.10129 0.129169 1.24273 0.246857 1.35343Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropDown);
export default __webpack_public_path__ + "static/media/iconDropDown.0a1811d13c207a4130bf7f0df296f57c.svg";
export { ForwardRef as ReactComponent };